import { Component } from '@angular/core';
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { Platform, ToastController } from '@ionic/angular';
import { UserService } from './generate-client';
import { UpdateUserPushTokenRequest } from './generate-client/model/updateUserPushTokenRequest';
import { LocalStorageService } from './services/local-storage-service.service';
import { UserLoginHandlerService } from './services/user-login-handler.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private oneSignal: OneSignal,
    private userLoginService: UserLoginHandlerService,
    private platform: Platform,
    private toastController: ToastController,
    private localStorageService: LocalStorageService,
    private userService: UserService
  ) {
    this.userLoginService.getObservable().subscribe(() => {
      this.subscribeToNotification();
    });

    this.initializeApp();
  }

  private async initializeApp() {
    await this.platform.ready()
    await this.startOneSignal();
  }

  private async startOneSignal() {

    await this.oneSignal.startInit('d0b096ef-2c17-437d-850b-e809909d51f4');

    this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert);

    this.oneSignal.handleNotificationReceived().subscribe(async x => {
      console.log("received");
      this.presentToast(JSON.stringify(x));
    });

    this.oneSignal.handleNotificationOpened().subscribe(async x => {
      console.log("opened");
      this.presentToast(JSON.stringify(x));
    });

    let userId = this.localStorageService.getUserId();

    if (userId) {
      this.oneSignal.sendTags({ user_id: userId });
    }

    await this.oneSignal.endInit();
  }

  private async subscribeToNotification() {

    let result = await this.oneSignal.getIds()
      .catch(async error => {
        console.log(error);
      });

    if (result) {
      let dto: UpdateUserPushTokenRequest = {
        cdUser: Number(this.localStorageService.getUserId()),
        dsToken: result.userId
      }

      await this.userService.apiUserUpdatePushTokenPut(dto).toPromise();
    }
  }

  private async presentToast(txt: string) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: "top",
      color: "dark",
    });

    toast.present();
  }
}
